import React from 'react';
import {
    Grid,
    Typography,
    Button,
    Card,
    CardContent,
    Avatar,
    Link,
    Box
} from '@material-ui/core';
import { useLogin, useNotify, Notification, translate } from 'react-admin';
import { ThemeProvider } from '@material-ui/styles';
import { withStyles } from '@material-ui/core/styles';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

const backgrounds = [
    'https://reshape.sport1.de/c/t/3958432b-c034-427e-83d6-f70fb0afb36c/0x0',
    'https://reshape.sport1.de/c/t/9949a829-078f-46d6-843f-799ac3912c16/0x0',
    'https://reshape.sport1.de/c/t/9d81586e-6e4a-46d5-9b8f-76fc1c381ebb/0x0',
    'https://reshape.sport1.de/c/t/ca5d5ef1-3139-4211-8e1a-45dc676df148/0x0',
    'https://reshape.sport1.de/c/t/e97f93c6-ac56-4467-b9d6-549734ac3d77/0x0',
]
const background = backgrounds[Math.floor(Math.random() * backgrounds.length)];

const styles = theme => {
    return {
        container: {
            alignItems: 'center',
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
            left: 0,
            position: 'absolute' as 'absolute',
            top: 0,
            width: '100vw',
        },
        logotypeContainer: {
            [theme.breakpoints.down('md')]: { display: 'none', },
            [theme.breakpoints.down('md')]: { width: '50%', },
            alignItems: 'center',
            background: 'url(' + background + ')',
            backgroundColor: theme.palette.primary.main,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column' as 'column',
            height: '100%',
            justifyContent: 'center',
            width: '60%',
        },
        formContainer: {
            [theme.breakpoints.down('md')]: { width: '50%', },
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column' as 'column',
            height: '100%',
            justifyContent: 'center',
            width: '40%',
        },
        form: {
            marginTop: theme.spacing(1),
            width: 320,
        },
        msButton: {
            backgroundColor: 'white',
            marginTop: theme.spacing(6),
            textTransform: 'none' as 'none',
            width: '100%',
        },
        avatar: {
            backgroundColor: theme.palette.secondary.main,
            margin: theme.spacing(1),
        },
        paper: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column' as 'column',
        },
    };
};

const LoginPage = (props: any) => {
    const login = useLogin();

    const Copyright = () => {
        return (
            <Typography variant="body2" color="textSecondary" align="center">
                {'Copyright © '}
                <Link color="inherit" href="https://www.sport1.de/">
          Sport1 GmbH
                </Link>{' '}
                {new Date().getFullYear()}
                {'.'}
            </Typography>
        );
    };
    const {
        classes,
        theme
    } = props;

    const notify = useNotify();

    const handleLogin = () => {
        login({},'/').catch(
            (error: Error) => {
                notify(
                    typeof error === 'string'
                        ? error
                        : typeof error === 'undefined' || !error.message
                            ? 'ra.auth.sign_in_error'
                            : error.message,
                    'warning'
                );
            }
        );
    };

    return (
        <ThemeProvider theme={theme}>
            <Grid container className={classes.container}>
                <div className={classes.logotypeContainer}>
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                OZ
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                Media Asset Management
                            </Typography>
                            <Typography variant="body2" component="p">
                                Made with <span role="img" aria-label="love">❤️</span>  by Sport1
                            </Typography>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.formContainer}>
                    <div className={classes.form}>
                        <div className={classes.paper}>
                            <Avatar className={classes.avatar}>
                                <LockOutlinedIcon />
                            </Avatar>
                        </div>
                        <React.Fragment>
                            <Button size="large" className={classes.msButton} type="button" onClick={handleLogin}>
                                <img src="data:image/svg+xml;base64,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" style={{ width: '100%' }} alt="" />
                            </Button>
                            <div className={classes.actions}>
                                <Box mt={5}>
                                    <Copyright />
                                </Box>
                            </div>
                        </React.Fragment>
                    </div>
                </div>
            </Grid>
            <Notification />
        </ThemeProvider>
    );
};

export default translate(withStyles(styles)(LoginPage));
